import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="min-vh-100 d-flex align-items-center" style={{ background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)' }}>
      <div className="container text-center py-4">
        {/* REAKTOR Logo */}
        <div className="mb-4">
          <div className="d-inline-flex align-items-center justify-content-center rounded-circle shadow-lg"
            style={{
              width: 'clamp(80px, 20vw, 120px)',
              height: 'clamp(80px, 20vw, 120px)',
              background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
              boxShadow: '0 0 30px rgba(255, 215, 0, 0.4)'
            }}>
            <span className="fa-solid fa-bolt" style={{ fontSize: 'clamp(30px, 10vw, 60px)', color: '#1a1a2e' }}></span>
          </div>
        </div>

        <div className="card border-0 shadow-lg mx-auto" style={{ maxWidth: '600px', borderRadius: '20px', background: 'rgba(26, 26, 46, 0.9)', backdropFilter: 'blur(10px)' }}>
          <div className="card-body p-4 p-md-5">
            <h1 className="fw-bold mb-2" style={{ fontSize: 'clamp(2rem, 6vw, 3rem)', color: '#FFD700' }}>REAKTOR</h1>
            <h2 className="mb-4" style={{ fontSize: 'clamp(1.2rem, 3vw, 1.5rem)', color: '#FFA500' }}>La Roue des Emotions</h2>
            <p className="lead mb-4" style={{ color: '#ffffff', fontSize: 'clamp(1rem, 2.5vw, 1.2rem)' }}>Saint-Valentin 2026</p>

            <div className="mb-4">
              <h5 className="mb-3 text-light">Gagnez des lots exclusifs :</h5>
              <div className="d-flex justify-content-center gap-2 gap-md-3 flex-wrap">
                <div className="text-center">
                  <div className="rounded-circle d-inline-flex align-items-center justify-content-center mb-2"
                    style={{ width: 'clamp(60px, 15vw, 80px)', height: 'clamp(60px, 15vw, 80px)', background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)' }}>
                    <span className="fa-solid fa-shirt" style={{ fontSize: 'clamp(18px, 4vw, 28px)', color: '#1a1a2e' }}></span>
                  </div>
                  <small className="text-light">T-Shirts</small>
                </div>
                <div className="text-center">
                  <div className="rounded-circle d-inline-flex align-items-center justify-content-center mb-2"
                    style={{ width: 'clamp(60px, 15vw, 80px)', height: 'clamp(60px, 15vw, 80px)', background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)' }}>
                    <span className="fa-solid fa-gift" style={{ fontSize: 'clamp(18px, 4vw, 28px)', color: '#1a1a2e' }}></span>
                  </div>
                  <small className="text-light">Cadeaux</small>
                </div>
                <div className="text-center">
                  <div className="rounded-circle d-inline-flex align-items-center justify-content-center mb-2"
                    style={{ width: 'clamp(60px, 15vw, 80px)', height: 'clamp(60px, 15vw, 80px)', background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)' }}>
                    <span className="fa-solid fa-wine-bottle" style={{ fontSize: 'clamp(18px, 4vw, 28px)', color: '#1a1a2e' }}></span>
                  </div>
                  <small className="text-light">Bouteilles</small>
                </div>
              </div>
            </div>

            <hr className="my-4" style={{ borderColor: 'rgba(255, 215, 0, 0.3)' }} />

            <div className="d-grid gap-3">
              <Link to="/login" className="btn btn-lg"
                style={{
                  background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
                  border: 'none',
                  color: '#1a1a2e',
                  fontWeight: 'bold',
                  borderRadius: '50px'
                }}>
                <i className="fa-solid fa-user-tie me-2"></i>Connexion Hotesse
              </Link>
              <Link to="/login" className="btn btn-lg"
                style={{
                  background: 'transparent',
                  border: '2px solid #FFD700',
                  color: '#FFD700',
                  fontWeight: 'bold',
                  borderRadius: '50px'
                }}>
                <i className="fa-solid fa-cog me-2"></i>Administration
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-4 text-white">
          <p className="mb-2" style={{ fontSize: 'clamp(0.9rem, 2vw, 1rem)' }}>Conditions de participation :</p>
          <div style={{ color: 'rgba(255, 255, 255, 0.75)', fontSize: 'clamp(0.8rem, 1.8vw, 0.95rem)' }}>
            <div>Achetez 2 bouteilles Reaktor minimum pour jouer</div>
            <div>1 participation par jour et par personne</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
